import React from "react"
import { Routes, Route, Navigate } from "react-router";
import {authedRoutes, publicRoutes} from '../../routes/index'
import { PUBLIC_ROUTES, ROUTES } from "../../routes/constants";
import { useAppSelector } from "../../core/store";


export default function AppRouter() {
    const user = useAppSelector(state => state.user)
    return (
        <Routes>
            {
            !user.user ?
            <>
            {publicRoutes.map(({path, Component}) => <Route key={path} path={path} element={<Component />} />)}
            <Route path="*" element={<Navigate to={PUBLIC_ROUTES.LOGIN_ROUTE} replace />} />
            </>
            :
            <>
            <Route path={PUBLIC_ROUTES.LOGIN_ROUTE} element={<Navigate to={PUBLIC_ROUTES.MAIN_ROUTE} />} />
            {publicRoutes.map(({path, Component}) => <Route key={path} path={path} element={<Component />} />)}
            {authedRoutes.map(({path, Component}) => <Route key={path} path={path} element={<Component />} />)}
            </>
            }
          
        </Routes>
    )
}